import { useState, useMemo } from 'react'
import { PlatformDevice } from '@/models/platformDevice'
import { SortColumn, SortDirection } from '@/components/PlatformDeviceTableHeader'

export function usePlatformDeviceSorting(filteredDevices: PlatformDevice[]) {
  const [sortColumn, setSortColumn] = useState<SortColumn>(null)
  const [sortDirection, setSortDirection] = useState<SortDirection>('asc')

  const handleSort = (column: keyof PlatformDevice) => {
    if (sortColumn === column) {
      setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc')
    } else {
      setSortColumn(column)
      setSortDirection('asc')
    }
  }

  const sortedDevices = useMemo(() => {
    if (!sortColumn) return filteredDevices

    return [...filteredDevices].sort((a, b) => {
      const aVal = a[sortColumn]
      const bVal = b[sortColumn]

      if (aVal === null || aVal === undefined) return 1
      if (bVal === null || bVal === undefined) return -1

      let comparison = 0
      if (typeof aVal === 'string' && typeof bVal === 'string') {
        comparison = aVal.localeCompare(bVal)
      } else if (typeof aVal === 'number' && typeof bVal === 'number') {
        comparison = aVal - bVal
      } else {
        comparison = String(aVal).localeCompare(String(bVal))
      }

      return sortDirection === 'asc' ? comparison : -comparison
    })
  }, [filteredDevices, sortColumn, sortDirection])

  return {
    sortColumn,
    sortDirection,
    sortedDevices,
    handleSort
  }
}